export function toClassName(...args) {
    return args.filter((it) => it).join(' ');
}
//# sourceMappingURL=ClassNameUtils.js.map